import type { UploadFile, VideoType } from 'lib/media-upload-file';
import type { Media } from 'models';
import { useMemo } from 'react';
import type { UploadFile as UploadFileUi } from 'ui';

type P = {
  file?: UploadFile;
  mediaData?: Media;
  type: VideoType;
};

const getStatus = ({ file }: { file: UploadFile }) => {
  // eslint-disable-next-line @typescript-eslint/switch-exhaustiveness-check -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
  switch (file.state.status) {
    case 'done':
    case 'error':
    case 'uploading':
      return file.state.status;
    default:
      return undefined;
  }
};

export const useFormFileInitialValue = ({ file, mediaData, type }: P): [UploadFileUi] | undefined =>
  useMemo(() => {
    if (mediaData) {
      return [
        {
          name: mediaData.name,
          status: 'done',
          uid: type,
        },
      ];
    }

    if (file?.state.status) {
      return [
        {
          name: file.file.name,
          status: getStatus({ file }),
          uid: type,
          // TODO: percent are missing to read from file if status is uploading
        },
      ];
    }

    return undefined;
  }, [mediaData, file, type]);
